import api from './api';


export const getAllEmailTemplates = (page, params) => {
  return api.get('admin/EmailTemplate', { params: { page: page, limit: 5, ...params } });
};

export const getEmailTemplate = (id) => {
  return api.get(`admin/template/email/${id}`);
}

export const createCustomTemplate = (uid, file) => {
  return api.post(`admin/upload/template/email/${uid}`, file);
}

export const updateCustomTemplate = (id, data) => {
  return api.put(`admin/upload/template/email/${id}`, data);
}

export const deleteCustomTemplate = (id) => {
  return api.delete(`admin/template/email/${id}`);
}